export default (function (question) {
    var choices = question.choices.map(function (choice) {
        return {
            'code': choice.choiceCode,
            'name': choice.displayKey
        };
    });

    return {
        'availableValues': {
            value: choices
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-js/aspects/AvailableValues.js
// module id = 902
// module chunks = 0